import { useI18n } from '../i18n/I18nProvider';
import { Button, Row } from './primitives';

/**
 * Previous and next under a paged list, with where the list is in the tenant's numerals. Nothing for a list of one
 * page.
 */
export function Pager({ page, totalPages, onPage }: {
  page: number;
  /** The list's page count as last read; nothing is drawn until it is known. */
  totalPages: number | undefined;
  onPage: (page: number) => void;
}) {
  const { t, formatNumber } = useI18n();
  if (totalPages === undefined || totalPages <= 1) return null;

  return (
    <Row between>
      <Button variant="secondary" disabled={page <= 1} onClick={() => onPage(page - 1)}>
        {t('action.previous')}
      </Button>
      <span>{t('paging.position', { page: formatNumber(page), total: formatNumber(totalPages) })}</span>
      <Button variant="secondary" disabled={page >= totalPages} onClick={() => onPage(page + 1)}>
        {t('action.next')}
      </Button>
    </Row>
  );
}
